var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedDentist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4558 3.50366C16.1705 2.83211 17.3293 2.83211 18.0441 3.50366L21.1816 6.45156C21.5248 6.77405 21.7176 7.21144 21.7176 7.66751V15.0642C22.0795 15.4948 22.1017 16.1144 21.7368 16.5716C21.2953 17.1247 20.457 17.2301 19.8762 16.8057L16.5103 14.346C16.3267 14.2118 16.1008 14.139 15.8682 14.139H7.24775C6.97038 14.139 6.70437 14.0355 6.50823 13.8512L2.37906 9.97153C1.92366 9.54365 1.87242 8.86625 2.25884 8.38216C2.73138 7.79018 3.65238 7.72868 4.20926 8.25192L7.55406 11.3946C7.7502 11.5789 8.01621 11.6824 8.29358 11.6824H16.906C17.1435 11.6824 17.3739 11.7583 17.5593 11.8977L20.1489 13.8442V7.66751C20.1489 7.60236 20.1213 7.53988 20.0723 7.4938L16.9348 4.5459C16.8327 4.44997 16.6672 4.44997 16.5651 4.5459L15.2129 5.81634L15.5734 6.15503C16.2232 6.76556 16.2232 7.75542 15.5734 8.36595C15.3568 8.56946 15.0056 8.56946 14.789 8.36595L11.3901 5.17239C11.1735 4.96888 11.1735 4.63893 11.3901 4.43542C12.0398 3.82489 13.0934 3.82489 13.7432 4.43542L14.1036 4.7741L15.4558 3.50366Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81458 22C6.81458 20.9146 7.75104 20.0347 8.90624 20.0347H15.1812C16.3364 20.0347 17.2729 20.9146 17.2729 22H6.81458Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90619 18.5607V15.6129H15.1812V18.5607H8.90619Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedDentist);
export default __webpack_public_path__ + "static/media/bed-dentist.2125e018e486508ba5d4a610e4351dc3.svg";
export { ForwardRef as ReactComponent };